export const CAMERA_ORDER = {
    FRONT_LEFT: 0,
    REAR_LEFT: 1,
    REAR: 2,
    REAR_RIGHT: 3,
    FRONT_RIGHT: 4,
    TOP: 5
};
